<template>
    <v-textarea
        :label="requiredCharLabel"
        :name="nameInput"
        color="success"
        v-model="value" 
        hide-details="auto" 
        underlined 
        dense 
        rows="3"
        :rules="rule"
        :error-messages="errorMessages"
        :counter="counter"
        :disabled="disabled"
    ></v-textarea>

</template>
<script>
export default {
    props: ['valueInput', 'rule', 'label', 'errorMessages', 'counter', 'nameInput', 'disabled'],
    model: {
        prop: 'value',
        event: 'valueChange'
    },
    computed: {
        value: {
            get: function() {
                return this.valueInput
            },
            set: function(value) {
                this.$emit('valueChange', value)
            }
        },
        requiredCharLabel:{
            get: function(){
                if(this.label == "" || this.label == undefined)
                    return "";
                const response = this.label + " *";
                for (let i = 0; i < (this?.rule?.length??[]); i++) {
                    if(this.rule[i]("") != true){
                        return response;
                    }
                }
                return this.label;
            }
        }
    }
}
</script>